@if (teamId && teamId !== 'current') {
  @if (compact) {
    @if (flyers.length > 0) {
      <button mat-stroked-button type="button" [matMenuTriggerFor]="flyerMenu" [disabled]="busy || loading">
        <mat-icon>picture_as_pdf</mat-icon> Benefits-at-a-glance
      </button>
      <mat-menu #flyerMenu="matMenu">
        @for (flyer of flyers; track flyer.id) {
          <button mat-menu-item type="button" (click)="download(flyer)">{{ flyer.displayName }}</button>
        }
      </mat-menu>
    }
  } @else if (canManage || flyers.length > 0) {
    <section class="flyers" aria-label="Benefits-at-a-glance">
      <h2>Benefits-at-a-glance</h2>
      <p>Download flyers to share with your staff.</p>
      @for (flyer of flyers; track flyer.id) {
        <div class="flyer-row">
          <div class="flyer-name"><strong>{{ flyer.displayName }}</strong><span>{{ flyer.filename }}</span></div>
          <div class="flyer-actions">
            <button mat-stroked-button type="button" [disabled]="busy || loading" (click)="download(flyer)">Download</button>
            @if (canManage) {
              <button mat-button type="button" [disabled]="busy || loading" (click)="replace(flyer)">Replace</button>
              <button mat-button type="button" [disabled]="busy || loading" (click)="remove(flyer)">Remove</button>
            }
          </div>
        </div>
      }
      @if (canManage) {
        @if (!loading && flyers.length === 0) { <p>No flyers uploaded for this wellspace.</p> }
        <div class="upload-form">
          <h3>{{ replacing ? 'Replace flyer: ' + replacing.displayName : 'Upload a flyer' }}</h3>
          <mat-form-field appearance="outline">
            <mat-label>Flyer name</mat-label>
            <input matInput [(ngModel)]="displayName" maxlength="160" [disabled]="busy" placeholder="e.g. Full-time benefits" />
          </mat-form-field>
          <div class="flyer-actions">
            <input #pdfInput type="file" accept="application/pdf,.pdf" hidden (change)="selectFile($event)" />
            <button mat-stroked-button type="button" [disabled]="busy" (click)="pdfInput.click()">Choose PDF</button>
            <span>{{ file ? file.name : 'PDF, up to 10 MB' }}</span>
          </div>
          <div class="flyer-actions">
            <button mat-raised-button color="primary" type="button" [disabled]="busy || loading || !file || !displayName.trim()" (click)="save()">
              {{ busy ? 'Working…' : replacing ? 'Save replacement' : 'Upload flyer' }}
            </button>
            @if (replacing || file || displayName) {
              <button mat-button type="button" [disabled]="busy" (click)="resetForm()">Cancel</button>
            }
          </div>
        </div>
      }
    </section>
  }
  @if (loading) { <span class="flyer-status" role="status">Loading Benefits-at-a-glance…</span> }
  @if (error) {
    <div class="flyer-error" role="alert">{{ error }} <button mat-button type="button" [disabled]="busy || loading" (click)="load()">Refresh flyers</button></div>
  }
}
